import {MenuItem, Select} from '@mui/material';
import PropTypes from 'prop-types';

const AdmicitySelect = ({options, value, onChange, defaultValue = true, widthValue = '50%', disabled}) => {
    const hasEmptyValue = value === '' || value === null || value === undefined;

    return (
        <Select
            value={value ?? ''}
            onChange={onChange}
            sx={{width: widthValue}}
            disabled={disabled}
            displayEmpty={defaultValue}
            variant="standard"
        >
            {defaultValue && hasEmptyValue && <MenuItem key="" value=""></MenuItem>}
            {options && options.map(option =>
                <MenuItem
                    key={option.key ?? option.value ?? option.title}
                    value={option.value}
                    disabled={option.disabled}
                >
                    {option.title}
                </MenuItem>)}
        </Select>
    );
};

AdmicitySelect.propTypes = {
    options: PropTypes.array.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    defaultValue: PropTypes.bool,
    widthValue: PropTypes.string,
    disabled: PropTypes.bool,
};
export default AdmicitySelect;
